import { ImportIcon as ImportIc } from "lucide-react";
import React from "react";

import cn from "@/helpers/classNames";

export default function ImportIcon(
  props: React.ComponentProps<typeof ImportIc>,
) {
  return (
    <ImportIc {...props} className={cn("translate-y-px", props.className)} />
  );
}
